export function CloudTalkLogo() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14224_68815)">
        <path 
          d="M17.3492 0H10.6508C4.76851 0 0 4.76851 0 10.6508V17.3492C0 23.2315 4.76851 28 10.6508 28H17.3492C23.2315 28 28 23.2315 28 17.3492V10.6508C28 4.76851 23.2315 0 17.3492 0Z" 
          fill="#64748B"
        />
        <path 
          d="M12.9509 19.9123C13.2848 19.9123 13.3602 20.117 13.4643 20.4257L13.9525 21.9657C14.0027 22.1452 14.1068 22.2206 14.2612 22.2206H14.4658C14.6202 22.2206 14.7207 22.1452 14.7745 21.9657L15.2627 20.4257C15.3668 20.117 15.392 19.8872 16.0309 19.8872C17.4668 19.8872 18.8273 19.6826 19.8504 18.6811C20.3386 18.1929 20.9273 18.0134 21.4909 18.3975L21.9791 18.7313C22.672 19.1944 22.8766 20.0631 22.313 20.6554C20.8771 22.1164 18.8525 22.9888 16.5443 22.9888H12.6996C8.13708 22.9888 4.75195 19.6036 4.75195 15.1164V12.9123C4.75195 8.42517 8.13708 5.04004 12.6996 5.04004H16.5443C18.8525 5.04004 20.8771 5.91235 22.313 7.37337C22.8766 7.96209 22.672 8.8344 21.9791 9.29747L21.4909 9.63132C20.9273 10.0154 20.3386 9.83594 19.8504 9.34773C18.8237 8.34619 17.4668 8.14158 16.0309 8.14158L12.9545 8.11645C9.774 8.09132 8.08324 10.0657 8.08324 12.9123V15.1164C8.08324 17.9631 9.774 19.9123 12.9545 19.9123H12.9509Z" 
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14224_68815">
          <rect width="28" height="28" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
} 